import classnames from 'classnames';
import React from 'react';
import Pagination from '../pagination';
import Skeleton from '../skeleton';
import Space from '../space';
import { useConfig } from '../hooks/useConfig';
import { getTransedText } from '../locale';
import BasicLayout from './basic-layout';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ListLayoutBody = props => {
  var _ref, _props$total;
  const {
    children,
    search,
    action,
    information1,
    information2,
    sufix,
    pagination,
    selectedTotal,
    initing = false,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const {
    locale: {
      Layout: LayoutLocale
    }
  } = useConfig();
  const baseClassName = "".concat(prefixClass, "-layout-list");
  const total = (_ref = (_props$total = props.total) !== null && _props$total !== void 0 ? _props$total : pagination === null || pagination === void 0 ? void 0 : pagination.total) !== null && _ref !== void 0 ? _ref : null;
  return /*#__PURE__*/_jsxs("div", {
    className: classnames(baseClassName, className),
    style: style,
    children: [!!information1 && /*#__PURE__*/_jsx(Skeleton.Node, {
      loading: initing,
      block: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "".concat(baseClassName, "--information1"),
        children: information1
      })
    }), !!search && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--search"),
      children: /*#__PURE__*/_jsx(Skeleton.Node, {
        loading: initing,
        block: true,
        children: search
      })
    }), !!information2 && /*#__PURE__*/_jsx(Skeleton.Node, {
      loading: initing,
      block: true,
      children: /*#__PURE__*/_jsx("div", {
        className: "".concat(baseClassName, "--information2"),
        children: information2
      })
    }), (!!action || typeof props.total === 'number' || typeof selectedTotal === 'number') && /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--prefix"),
      children: [/*#__PURE__*/_jsxs(Space, {
        isEmptyShow: true,
        children: [typeof props.total === 'number' && /*#__PURE__*/_jsx(Skeleton.Node, {
          loading: initing,
          children: /*#__PURE__*/_jsx("span", {
            children: getTransedText(LayoutLocale.layout_list_result, {
              total: total
            })
          })
        }), typeof selectedTotal === 'number' && selectedTotal > 0 && /*#__PURE__*/_jsx(Skeleton.Node, {
          loading: initing,
          children: /*#__PURE__*/_jsx("span", {
            className: "selectedTotal",
            children: getTransedText(LayoutLocale.layout_list_selectedTotal, {
              selectedTotal
            })
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "".concat(baseClassName, "--action"),
        children: /*#__PURE__*/_jsx(Skeleton.Node, {
          loading: initing,
          children: action
        })
      })]
    }), children, !!pagination && /*#__PURE__*/_jsxs("div", {
      className: "".concat(baseClassName, "--pagination"),
      style: {
        alignItems: 'flex-start'
      },
      children: [/*#__PURE__*/_jsxs(Space, {
        isEmptyShow: true,
        children: [typeof total === 'number' && /*#__PURE__*/_jsx(Skeleton.Node, {
          loading: initing,
          children: /*#__PURE__*/_jsx("span", {
            children: getTransedText(LayoutLocale.layout_list_result, {
              total
            })
          })
        }), typeof selectedTotal === 'number' && selectedTotal > 0 && /*#__PURE__*/_jsx(Skeleton.Node, {
          loading: initing,
          children: /*#__PURE__*/_jsx("span", {
            className: "selectedTotal",
            children: getTransedText(LayoutLocale.layout_list_selectedTotal, {
              selectedTotal
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Skeleton.Node, {
        loading: initing,
        children: /*#__PURE__*/_jsx(Pagination, {
          showTotal: () => '',
          ...pagination
        })
      })]
    }), !!sufix && /*#__PURE__*/_jsx("div", {
      className: "".concat(baseClassName, "--sufix"),
      children: sufix
    })]
  });
};
const ListLayout = props => {
  const {
    children,
    search,
    action,
    information1,
    information2,
    sufix,
    pagination,
    total,
    initing = false,
    ...basicLayoutProps
  } = props;
  return /*#__PURE__*/_jsx(BasicLayout, {
    initing: initing,
    ...basicLayoutProps,
    children: /*#__PURE__*/_jsx(ListLayoutBody, {
      search: search,
      action: action,
      information1: information1,
      information2: information2,
      sufix: sufix,
      pagination: pagination,
      total: total !== null && total !== void 0 ? total : pagination === null || pagination === void 0 ? void 0 : pagination.total,
      initing: initing,
      children: children
    })
  });
};
export default ListLayout;